import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppActions } from 'src/app/shared/store/app.reducer';
import { Store } from '@ngrx/store';
import { IState } from 'src/app/shared/store/root.reducer';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.scss']
})
export class PagenotfoundComponent implements OnInit {

  constructor(
    private router: Router,
    private store: Store<IState>
  ) { }

  ngOnInit() {
  }

  goBack() {
    this.router.navigate(['']);
    this.store.dispatch({
      type: AppActions.RELOAD_DATA,
      payload: true
    });
  }

}
